import RoiCalculatorPage from 'features/marketing/pages/RoiCalculatorPage';
import MigrationKitPage from 'features/marketing/pages/MigrationKitPage';
import SwitchFromDoinsportPage from 'features/marketing/pages/SwitchFromDoinsportPage';
import ReferralPage from 'features/marketing/pages/ReferralPage';
import HelpCenterLanding from 'features/help-center/public/HelpCenterLanding';
import HelpCategoryPage from 'features/help-center/public/HelpCategoryPage';
import HelpArticlePage from 'features/help-center/public/HelpArticlePage';

const marketingRoutes: RoutesType[] = [
  {
    name: 'ROI Calculator',
    layout: '/marketing',
    path: 'roi-calculator',
    icon: '',
    component: <RoiCalculatorPage />,
  },
  {
    name: 'Switch from Doinsport',
    layout: '/marketing',
    path: 'switch-from-doinsport',
    icon: '',
    component: <SwitchFromDoinsportPage />,
  },
  {
    name: 'Migration Kit',
    layout: '/marketing',
    path: 'migration-kit',
    icon: '',
    component: <MigrationKitPage />,
  },
  {
    name: 'Referral',
    layout: '/marketing',
    path: 'referral',
    icon: '',
    component: <ReferralPage />,
  },
  {
    name: 'Help Center',
    layout: '/marketing',
    path: 'help',
    icon: '',
    component: <HelpCenterLanding />,
  },
  {
    name: 'Help Category',
    layout: '/marketing',
    path: 'help/:categorySlug',
    icon: '',
    component: <HelpCategoryPage />,
  },
  {
    name: 'Help Article',
    layout: '/marketing',
    path: 'help/:categorySlug/:articleSlug',
    icon: '',
    component: <HelpArticlePage />,
  },
];

export default marketingRoutes;
